/**
 * Roles in the Agency MFA enforcement matrix.
 *
 * These are wire identifiers used by the API, not display text — always map them to a translation
 * constant before rendering.
 */
export enum MfaRole {
  EMPLOYEE = 'Employee',
  MANAGER = 'Manager',
  SUPER_ADMIN = 'SuperAdmin',
}
